import React, { Component } from 'react';
import {
  TextField,
  Button,
  Paper,
  Container,
  Item,
  FileInput,
  FeatureInput,
  FormControlLabel,
  Switch,
  CategorySearchInput,
  Chip,
  ListItem,
  ListItemText,
} from 'components';
import { withStyles, createStyleSheet } from 'material-ui/styles';

const styleSheet = createStyleSheet('ToolForm', () => ({
  paper: {
    padding: 16,
  },
  form: {
    textAlign: 'center',
  },
  submitButton: {
    width: '100%',
    marginTop: 32,
  },
  chip: {
    margin: 4,
  },
}));

class ToolForm extends Component {
  state = {
    name: null,
    description: null,
    detail: null,
    url: null,
    imageId: null,
    imageUrl: null,
    isOpenSource: false,
    sourceUrl: null,
    categoriesIds: [],
    featuresIds: [],

    items: [],
  };

  handleTextFieldChange = e => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.onSubmit(this.state);
  };

  render() {
    const { classes } = this.props;

    return (
      <Container justify="center">
        <Item md={6} lg={4}>
          <Paper className={classes.paper}>
            <form onSubmit={this.handleSubmit}>
              <FileInput
                onSuccess={imageData => {
                  const { id, url } = imageData;
                  this.setState({
                    imageId: id,
                    imageUrl: url,
                  });
                }}
                onFailure={error => {
                  console.error('error', error);
                  this.setState({
                    imageId: null,
                    imageUrl: null,
                  });
                }}
              />

              <TextField
                fullWidth
                required
                label="이름 (필수)"
                name="name"
                type="text"
                onChange={this.handleTextFieldChange}
              />

              <TextField
                fullWidth
                label="간단한 설명"
                name="description"
                type="text"
                onChange={this.handleTextFieldChange}
              />

              <TextField
                fullWidth
                label="자세한 설명"
                name="detail"
                type="text"
                onChange={this.handleTextFieldChange}
              />

              <TextField
                fullWidth
                label="사이트"
                name="url"
                type="text"
                onChange={this.handleTextFieldChange}
              />

              <FormControlLabel
                control={
                  <Switch
                    checked={this.state.isOpenSource}
                    name="isOpenSource"
                    onChange={(event, checked) =>
                      this.setState({ isOpenSource: checked })}
                  />
                }
                label="오픈 소스 인가요?"
              />

              {this.state.isOpenSource &&
                <TextField
                  fullWidth
                  label="오픈소스 URL"
                  name="sourceUrl"
                  type="text"
                  onChange={this.handleTextFieldChange}
                />}

              <CategorySearchInput
                fullWidth
                items={this.state.items}
                name="categoriesIds"
                type="text"
                label="검색으로 카테고리 추가 (필수)"
                helperText="여러개 추가 가능"
                onAddItems={items => {
                  this.setState({
                    categoriesIds: items.map(item => item.id),
                  });
                }}
                renderItem={item => {
                  const { id, label } = item;

                  return (
                    <Chip key={id} label={label} className={classes.chip} />
                  );
                }}
                renderSearchItem={data => {
                  const { id, label } = data;

                  return (
                    <ListItem dense button key={id}>
                      <ListItemText primary={label} />
                    </ListItem>
                  );
                }}
                error={this.state.error}
                required
              />

              <FeatureInput
                fullWidth
                label="기능 추가"
                helperText="여러개 추가 가능"
                name="features"
                type="text"
                onAdd={({ id, label, slug }) => {
                  this.setState(prevState => {
                    return {
                      featuresIds: [...prevState.featuresIds, id],
                    };
                  });
                }}
              />

              <Button
                type="submit"
                color="primary"
                className={classes.submitButton}
                raised
              >
                추가하기
              </Button>
            </form>
          </Paper>
        </Item>
      </Container>
    );
  }
}
export default withStyles(styleSheet)(ToolForm);



// WEBPACK FOOTER //
// ./src/App/Tool/components/ToolForm.js